var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1609_5743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1609_5743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 12.6667H5.3335C4.96683 12.6667 4.65294 12.5361 4.39183 12.275C4.13072 12.0139 4.00016 11.7 4.00016 11.3333V1.99999C4.00016 1.63332 4.13072 1.31943 4.39183 1.05832C4.65294 0.797212 4.96683 0.666656 5.3335 0.666656H10.0002L14.0002 4.66666V11.3333C14.0002 11.7 13.8696 12.0139 13.6085 12.275C13.3474 12.5361 13.0335 12.6667 12.6668 12.6667ZM9.3335 5.33332V1.99999H5.3335V11.3333H12.6668V5.33332H9.3335ZM2.66683 15.3333C2.30016 15.3333 1.98627 15.2028 1.72516 14.9417C1.46405 14.6805 1.3335 14.3667 1.3335 14V4.66666H2.66683V14H10.0002V15.3333H2.66683Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.afa0a492c9589f9c51b96f93ae0f0d44.svg";
export { ForwardRef as ReactComponent };